const ALLOWED_CHALLENGES = new Set([
  "controle",
  "metas",
  "dados",
  "campanhas",
  "margem",
  "carteira",
]);
const VALID_BRAZILIAN_DDDS = new Set([
  11, 12, 13, 14, 15, 16, 17, 18, 19,
  21, 22, 24, 27, 28,
  31, 32, 33, 34, 35, 37, 38,
  41, 42, 43, 44, 45, 46, 47, 48, 49,
  51, 53, 54, 55,
  61, 62, 63, 64, 65, 66, 67, 68, 69,
  71, 73, 74, 75, 77, 79,
  81, 82, 83, 84, 85, 86, 87, 88, 89,
  91, 92, 93, 94, 95, 96, 97, 98, 99,
]);

export function normalizeBrazilianPhone(value) {
  let digits = String(value || "").replace(/\D/g, "");

  if (digits.startsWith("55") && (digits.length === 12 || digits.length === 13)) {
    digits = digits.slice(2);
  }

  if (digits.length !== 10 && digits.length !== 11) {
    throw new Error("WhatsApp inválido. Informe DDD e número.");
  }

  const ddd = Number(digits.slice(0, 2));
  const localNumber = digits.slice(2);
  const validLocalNumber = digits.length === 11
    ? /^9[6-9]\d{7}$/.test(localNumber)
    : /^[2-5]\d{7}$/.test(localNumber);

  if (!VALID_BRAZILIAN_DDDS.has(ddd) || !validLocalNumber) {
    throw new Error("WhatsApp inválido. Informe DDD e número.");
  }

  return `+55${digits}`;
}

export function createIdempotencyKey() {
  return crypto.randomUUID();
}

export function buildDiagnosticPayload(formData, meta) {
  const challenges = formData
    .getAll("desafio")
    .filter((value) => ALLOWED_CHALLENGES.has(value));

  return {
    companyName: String(formData.get("empresa") || "").trim(),
    sector: String(formData.get("setor") || "").trim(),
    salesTeamSize: String(formData.get("equipe") || "").trim(),
    cityState: String(formData.get("cidade") || "").trim(),
    challenges,
    context: String(formData.get("contexto") || "").trim(),
    contactName: String(formData.get("nome") || "").trim(),
    jobRole: String(formData.get("cargo") || "").trim(),
    email: String(formData.get("email") || "").trim().toLowerCase(),
    phone: normalizeBrazilianPhone(formData.get("fone")),
    consent: formData.get("consentimento") === "on",
    website: String(formData.get("website") || ""),
    startedAt: new Date(meta.startedAt).toISOString(),
    submittedAt: new Date(meta.submittedAt).toISOString(),
    idempotencyKey: meta.idempotencyKey,
    source: "site",
  };
}
